<script>
  import InfoIcon from "@/assets/images/info-icon.svg";
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "InfoIcon",
    setup() {
      return {
        InfoIcon
      };
    }
  });
</script>

<template>
  <img :src="InfoIcon" alt="Tooltip" />
</template>
